import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: ''
}

export const fetchKeyExecutives = createAsyncThunk("fetchKeyExecutives", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'keyexecutives',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchKeyExecutives.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchKeyExecutives.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchKeyExecutives.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
